import { BasicResult } from "../basic-result";
import { CampaignDetail } from "./campaign-detail";

export class CampaignDetailResult extends BasicResult {
    public CampaignDetails: CampaignDetail[] = [];
    constructor(values: Object = {}) {
        super();
        Object.assign(this, values);
        if (values.hasOwnProperty('CampaignDetails')) {
            this.CampaignDetails = [];
            ((values as CampaignDetailResult)['CampaignDetails'] as CampaignDetail[]).forEach(element => {
                this.CampaignDetails.push(new CampaignDetail(element));
            });
        }


    }
}